
import Vue from 'vue'
import { SaveButton } from '@/components/buttons'
import { Currency } from '@/components'
import { CartTotalsModel } from '@ViewModels/CartTotalsModel'

export default Vue.extend({
   name: 'OrderTotals',
   data() {
      return {
         submitted: false,
         submitting: false,
         promocodeText: '',
         errorMessage: '',
      }
   },
   computed: {
      showSubtotal(): boolean {
         return this.showShipping || this.showClickAndCollect || this.showDiscount
      },
      showShipping(): boolean {
         return this.$store.getters.requiresDelivery && !this.$store.getters.clickAndCollect
      },
      showClickAndCollect(): boolean {
         return this.$store.getters.clickAndCollect
      },      
      showDiscount(): boolean {
         return this.totals.PromoCodeDiscountAmount > 0
      },
      showDivider(): boolean {
         return this.showSubtotal
      },
      currencyCode(): string {
         return this.$store.state.modelData.CurrencyCode
      },
      totals(): CartTotalsModel {
         return this.$store.state.modelData.Totals
      },
      subtotal(): number {
         return this.totals.SubTotal
      },
      shipping(): number {
         return this.totals.DeliveryCharge
      },
      discount(): number {
         return this.totals.PromoCodeDiscountAmount * -1
      },
      useStoreCredit(): boolean {
         return this.$store.getters.useStoreCredit
      },
      storeCreditApplied(): number {
         return this.totals.StoreCreditApplied * -1
      },
      grandTotal(): number {
         return this.totals.GrandTotal
      },
   },
   methods: {
      removePromocode(code: string) {
         this.$store.dispatch('removePromocode', code)
      },
   },
   components: {
      SaveButton,
      Currency,
   },
})
